import {
  AppLayout,
  ContentLayout,
  BreadcrumbGroupProps,
  AppLayoutProps,
  HeaderProps,
  SpaceBetween,
  Box,
  Link,
} from '@cloudscape-design/components';
import { useContext } from 'react';

import { LocalNavigation, Breadcrumbs, NavigationContext } from '../common/navigation';

export type ViewLayoutProps = {
  header?: React.ReactNode;
  secondaryHeader?: React.ReactNode;
  breadcrumbs?: BreadcrumbGroupProps.Item[];
  children: React.ReactNode;
  contentType?: AppLayoutProps.ContentType;
  navigationHide?: boolean;
  headerVariant?: 'default' | 'high-contrast';
};

export function ViewLayout(props: ViewLayoutProps) {
  const { navigationSize, navigationOpen, setNavigationOpen } = useContext(NavigationContext);

  return (
    <AppLayout
      breadcrumbs={props.breadcrumbs ? <Breadcrumbs items={props.breadcrumbs} /> : undefined}
      className="app-layout"
      content={
        <ContentLayout
          header={props.header}
          secondaryHeader={props.secondaryHeader}
          headerVariant={props.headerVariant}
        >
          {props.children}
        </ContentLayout>
      }
      headerVariant={props.headerVariant}
      contentType={props.contentType ?? 'default'}
      headerSelector=".top-navigation"
      navigation={<LocalNavigation />}
      navigationOpen={navigationOpen}
      navigationWidth={navigationSize}
      navigationHide={props.navigationHide}
      toolsHide
      onNavigationChange={(event) => setNavigationOpen(event.detail.open)}
      maxContentWidth={1000}
    />
  );
}
